import { useEffect, useState } from 'react'
import { appConfigResponseSchema } from '@repo/shared'
import { env } from '../env'

export type AppConfigResponse = ReturnType<typeof appConfigResponseSchema.parse>

/**
 * 두 겹 스위치 읽기: GET /config 를 한 번 읽어 pick 으로 고른다 (서버 코드 features 와 관리자 settings 를 함께 본다).
 * 읽지 못하거나 옛 서버라 칸이 없으면 꺼진 것으로 본다
 */
export function useConfigSwitch(pick: (config: AppConfigResponse) => boolean): boolean {
  const [enabled, setEnabled] = useState(false)
  useEffect(() => {
    let alive = true
    void fetch(`${env.API_URL}/config`)
      .then((r) => (r.ok ? r.json() : Promise.reject()))
      .then((raw) => {
        if (alive) setEnabled(pick(appConfigResponseSchema.parse(raw)))
      })
      .catch(() => {
        if (alive) setEnabled(false)
      })
    return () => {
      alive = false
    }
    // pick 은 호출하는 쪽의 고정 함수다 — 화면이 열릴 때 한 번만 읽는다
  }, [])
  return enabled
}
